(function() {
    
    $('[js-product="slider"]').slick({
        dots: false,
        adaptiveHeight: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        autoplay: false,
        arrows: true,
        responsive: [
            {
                breakpoint:1024,
                settings: {
                    arrows:false,
                    dots:true
                }
            }
        ]
    });

    $('[js-product="slider-nav"] img').on('click', function(e){
        e.preventDefault();
        var index = $(this).data('index');
        $('[js-product="slider"]').slick('slickGoTo', index);
    });

})();